import script from "./PortfolioTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioTable.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioTable.vue?vue&type=style&index=0&id=265f0dc3&scoped=true&lang=scss"
import "./PortfolioTable.vue?vue&type=style&index=1&id=265f0dc3&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265f0dc3"]])

export default __exports__